module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAwCAMAAAA8VkqRAAAAWlBMVEUAAAB+0yH6/fb////8/fq/6ZGD1Sn4/PLn99a654m554by+unS77HO7qzF65zC6pWp4Wug3l2Z3FCJ1jPz++ve88bU8Laz5X2y5Hud3VeX202Q2UCM2DqA0yQksRdyAAAAAXRSTlMAQObYZgAAAIlJREFUOMvt0VcOwjAQBNAws9hOb/Ry/2sSmmTEhF+iKPNnPcvaHSerkfyCRGSBeYPKv6CtNbRkpaD39I2CrWGnnjqAGyfgDKITU12DYR2N66r981DDQrxHSf+414G4xHA0YhCXE83n5inuUgJFXMlbCjB3X11loBEnUeIgSGW7GcNI7f0U/vyVG5QdBZpruxPPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/check-green.png
// module id = 663
// module chunks = 1